import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  body {
    -webkit-font-smoothing: antialiased;
    background: #fff;
  }
  body, input, button {
    font: 16px 'Roboto Slab', sans-serif !important;
  }
 h1,h2,h3,h4,h5,h6, strong{
   font-weight: 500;
 }
  button {
    cursor: pointer;

  }

  .slotRodape{

  }

.ant-layout-content{
  background: #f7f7f7 !important;
}

.ant-card-body{
  margin-top: 50px;
  margin-right: 10%;
  margin-left: 10%;
  margin-bottom: 20%;
  padding: 5% 8%;

  background: #ffffff;
  border: 1px solid #cecece;
  border-radius: 5px;


}
.ant-form-item-control-input{
  min-height: 0px !important;
}

.ant-descriptions-item-label {
  font-weight: 600;
  color: #3b3b3b !important;
  font-size: 0.8rem !important;

}

.ant-descriptions p{
  color: #3b3b3b !important;
  font-size: 0.8rem;
}

.divider {
  border-top: 1px solid #cecece;
}




.ant-card{
  background: #f7f7f7;
  margin: 0 auto;
}



.sizeBoxHeight {
    height: 20px;
  }

  .sizeBoxWidth {
    width: 20px;
  }


  .ant-select-selector{

    border-radius: 50px !important;
  }

  .ant-btn {
    border-radius: 50px;
  }

  @media (max-width: 600px) {
    .ant-card-body{
      margin-right: 5%;
      margin-left: 5%;
      margin-top: 20px;
    }

    .ant-card .btnBack{
  display: none;
}
  }

`;
